import PropTypes from "prop-types";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const SectionCard = ({ title, children }) => (
  <Card>
    <CardHeader>
      <CardTitle>{title}</CardTitle>
    </CardHeader>
    <CardContent className="tw:flex tw:flex-col tw:gap-5">
      {children}
    </CardContent>
  </Card>
);

SectionCard.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node,
};

export default SectionCard;
